import { track } from "../track";

export const trackAvatarsPageView = (params: { view_count: number }) =>
  track({ event: "avatars_page_view", ...params });
